export var ProjectSheetToleranceType;
(function (ProjectSheetToleranceType) {
    ProjectSheetToleranceType["WithinTolerance"] = "within_tolerance";
    ProjectSheetToleranceType["GteDesignedValue"] = "gte_designed_value";
    ProjectSheetToleranceType["LteDesignedValue"] = "lte_designed_value";
    ProjectSheetToleranceType["AsymmetricTolerance"] = "asymmetric_tolerance";
})(ProjectSheetToleranceType || (ProjectSheetToleranceType = {}));
export var ProjectSheetItemsOrder;
(function (ProjectSheetItemsOrder) {
    ProjectSheetItemsOrder["Name"] = "by_element_name";
    ProjectSheetItemsOrder["CreatedAt"] = "by_created_at";
    ProjectSheetItemsOrder["CustomOrder"] = "by_display_order_on_3d_gui";
})(ProjectSheetItemsOrder || (ProjectSheetItemsOrder = {}));
/**
 * Which aggregate a かぶり厚 (cover-thickness) row shows / judges / exports.
 */
export var CoverThicknessAggregate;
(function (CoverThicknessAggregate) {
    CoverThicknessAggregate["Min"] = "min";
    CoverThicknessAggregate["Max"] = "max";
    CoverThicknessAggregate["Avg"] = "avg";
})(CoverThicknessAggregate || (CoverThicknessAggregate = {}));
